import BaseExecutor from 'services/sports/default/base-executor';
import {MinAdjustedPlayersValidatorBuilder} from 'services/sports/draftkings/validator/min-adjusted-players-validator-builder';
import Action from 'actions';
import BaseValidator from 'services/validations/base-validator';
import ProjectedOwnershipForceValidator from 'components/organisms/projected-ownership-force/validators/validator';
import {ForcedStackingValidatorBuilder} from 'services/sports/singlegame/validator/forced-stacking-validator-builder';
import {SingleGameValidatorBuilder} from 'services/validations/builders/single-game-validator-builder';

export default class UserAdjustmentsValidatorShowdownBuilder extends BaseExecutor {
    getInterface() {
        const {
            sportConfig,
            userPointsType,
            projectedOwnershipForce,
            playersData: {preparedPlayers},
            singlegameForcedStacking: {settings: stacking},
        } = Action.getState();

        const validator = new BaseValidator();

        const singleGameValidatorBuilder = new SingleGameValidatorBuilder({
            exposureMinPropNames: ['exposureMin', 'captain_exposureMin'],
        }).getInterface();
        validator.addSubValidators([singleGameValidatorBuilder]);

        if (projectedOwnershipForce.isEnabled()) {
            const projectedOwnershipForceValidator = new ProjectedOwnershipForceValidator();
            projectedOwnershipForceValidator.setDependencies({
                sportConfig,
                projectedOwnershipForce,
                players: preparedPlayers.groupedBy.playerId(),
            });
            validator.addSubValidators([projectedOwnershipForceValidator]);
        }

        if (!this._isAnyStackingUsed()) {
            const minAdjustedPlayersValidator = new MinAdjustedPlayersValidatorBuilder({
                propNameOfDefaultUserPointsValue: userPointsType.getUserPointsType(),
            }).getInterface();
            validator.addSubValidators([minAdjustedPlayersValidator]);
        }

        if (stacking.isEnabled()) {
            const forcedStackingValidatorBuilder = new ForcedStackingValidatorBuilder().getInterface();
            validator.addSubValidators([forcedStackingValidatorBuilder]);
        }

        return validator;
    }

    _isAnyStackingUsed() {
        return (
            this._isCptPositionStackingUsed() ||
            this._isPlayerCombinationStackingUsed() ||
            this._isProjectionBoostRuleUsed() ||
            this._isSinglegameForcedStackingUsed()
        );
    }

    _isCptPositionStackingUsed() {
        const {cptPositionStacking} = Action.getState();

        return cptPositionStacking.isEnabled() && cptPositionStacking.hasItems();
    }

    _isPlayerCombinationStackingUsed() {
        const {playerCombinationStacking} = Action.getState();

        return playerCombinationStacking.isEnabled() && playerCombinationStacking.hasItems();
    }

    _isProjectionBoostRuleUsed() {
        const {projectionBoostRule} = Action.getState();

        return projectionBoostRule.isEnabled() && projectionBoostRule.hasItems();
    }

    _isSinglegameForcedStackingUsed() {
        const {
            singlegameForcedStacking: {settings: stacking},
        } = Action.getState();

        return stacking.isEnabled();
    }
}
